import { SearchService } from 'src/app/services/search.service';
import { Component, OnInit } from '@angular/core';
import { BookingService } from 'src/app/services/booking.service';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';

@Component({
  selector: 'terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  termsAndConditions;
  viewBooking:ViewBookingModel;
  constructor(private bookingService: BookingService,private searchService:SearchService) { }

  ngOnInit() {
    
    this.bookingService.viewBookingModel.subscribe(res => {
      
      this.viewBooking=res;
      if(res!=null){
        this.loadTermsAndConditions();
      }

    })
  
  }
  loadTermsAndConditions(){
    if(this.termsAndConditions==null||this.termsAndConditions==''){

      this.bookingService.getTermsAndCondition(this.viewBooking.agencyID).subscribe(res => {
          this.termsAndConditions = res;
      });
      
  }
  }

}
